import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
    ProSidebar,
    SidebarHeader,
    SidebarFooter,
    SidebarContent,
    Menu,
    MenuItem,
    SubMenu } from 'react-pro-sidebar';
import {
    FaUserFriends,
    FaStore,
    FaRoute,
    FaBoxes,
    FaBox,
    FaMapMarkerAlt } from 'react-icons/fa';

import { isAdmin } from "../../services/auth";

import './styles.css';

export default function Sidebar(props) {
    const { page } = props;
    const [openMenu, setOpenMenu]  = useState({
        user: false,
        product: false,
        competitors: false,
        route: false,
        store: false,
        visit: false,
        promoter: false
    });

    function menuClick (param) {
        switch (param) {
            case "user":
                setOpenMenu(state => ({
                    ...state,
                    user: !state['user']
                }));
                break;
            case "promoter":
                setOpenMenu(state => ({
                    ...state,
                    promoter: !state['promoter']
                }));
                break;
            case "product":
                setOpenMenu(state => ({
                    ...state,
                    product: !state['product']
                }));
                break;
            case "competitors":
                setOpenMenu(state => ({
                    ...state,
                    competitors: !state['competitors']
                }));
                break;
            case "route":
                setOpenMenu(state => ({
                    ...state,
                    route: !state['route']
                }));
            break;
            case "store":
                setOpenMenu(state => ({
                    ...state,
                    store: !state['store']
                }));
            break;
            case "visit":
                setOpenMenu(state => ({
                    ...state,
                    visit: !state['visit']
                }));
            break;
            default:
                break;
        }
    }

    useEffect(() => {
        const checkOpen = () => {
            if (page === "userlist" || page === "usernew") {
                setOpenMenu( state => ({
                    ...state,
                    user: true
                }));
            }

            if (page === "promoterlist") {
                setOpenMenu( state => ({
                    ...state,
                    user: true
                }));
            }

            if (page === "productlist" || page === "productnew") {
                setOpenMenu( state => ({
                    ...state,
                    product: true
                }));
            }

            if (page === "routelist" || page === "routenew") {
                setOpenMenu( state => ({
                    ...state,
                    route: true
                }));
            }

            if (page === "comptlist" || page === "comptnew") {
                setOpenMenu( state => ({
                    ...state,
                    competitors: true
                }));
            }

            if (page === "storelist" || page === "storenew") {
                setOpenMenu( state => ({
                    ...state,
                    store: true
                }));
            }

            if (page === "visitlist" || page === "map") {
                setOpenMenu( state => ({
                    ...state,
                    visit: true
                }));
            }
        }
        checkOpen();
    },[page]);

    const menus = [
        {
            type: 'user',
            title: 'Usuários',
            open : openMenu['user'],
            icon: <FaUserFriends />,
            admin: true,
            submenus: [
                {
                    page: 'promoterlist',
                    title: 'Listar promotores',
                    link: '/promoters',
                    admin: false
                },
                {
                    page: 'userlist',
                    title: 'Listar usuários',
                    link: '/users',
                    admin: false
                },
                {
                    page: 'usernew',
                    title: 'Cadastrar usuário',
                    link: '/users/new',
                    admin: true
                }
            ]
        },
        {
            type: 'store',
            title: 'Lojas',
            open : openMenu['store'],
            icon: <FaStore />,
            admin: false,
            submenus: [
                {
                    page: 'storelist',
                    title: 'Listar lojas',
                    link: '/stores',
                    admin: false
                },
                {
                    page: 'storenew',
                    title: 'Cadastrar loja',
                    link: '/stores/new',
                    admin: true
                }
            ]
        },
        {
            type: 'route',
            title: 'Rotas',
            open : openMenu['route'],
            icon: <FaRoute />,
            admin: false,
            submenus: [
                {
                    page: 'routelist',
                    title: 'Listar rotas',
                    link: '/routes',
                    admin: false
                },
                {
                    page: 'routenew',
                    title: 'Cadastrar rota',
                    link: '/routes/new',
                    admin: true
                }
            ]
        },
        {
            type: 'product',
            title: 'Produtos',
            open : openMenu['product'],
            icon: <FaBox />,
            admin: false,
            submenus: [
                {
                    page: 'productlist',
                    title: 'Listar produtos',
                    link: '/products',
                    admin: false
                },
                {
                    page: 'productnew',
                    title: 'Cadastrar produto',
                    link: '/products/new',
                    admin: true
                }
            ]
        },
        {
            type: 'competitors',
            title: 'Competidores',
            open : openMenu['competitors'],
            icon: <FaBoxes />,
            admin: false,
            submenus: [
                {
                    page: 'comptlist',
                    title: 'Listar competidores',
                    link: '/competitors',
                    admin: false
                },
                {
                    page: 'comptnew',
                    title: 'Cadastrar competidor',
                    link: '/competitors/new',
                    admin: true
                }
            ]
        },
        {
            type: 'visit',
            title: 'Visitas',
            open : openMenu['visit'],
            icon: <FaMapMarkerAlt />,
            admin: true,
            submenus: [
                {
                    page: 'visitlist',
                    title: 'Listar visitas',
                    link: '/visits',
                    admin: false
                },
                {
                    page: 'map',
                    title: 'Mapa de visitas',
                    link: '/map',
                    admin: false
                }
            ]
        }
    ]

    return (
        <div className="sidebar-container"
            >
            <ProSidebar
                //breakPoint="lg"
                //collapsed={true}
                >
                <SidebarHeader style={{
                    display: 'flex',
                    fontSize: '25px',
                    justifyContent: 'center',
                    borderBottom: '0px solid #DFDFDF',
                    borderRight: '1px solid #DFDFDF'
                    }}>
                    ProAtend
                </SidebarHeader>
                <SidebarContent
                    style={{
                        borderRight: '1px solid #DFDFDF',
                    }}>
                    {menus.map((menu, index) => {
                        if (!menu['admin'] || (menu['admin'] && isAdmin())) {
                            return (
                                <Menu
                                    popperArrow={true}
                                    key={index}
                                    style={{ padding: '0px'}}
                                    onClick={() => menuClick(menu['type'])}
                                    >
                                    <SubMenu
                                        title={menu['title']}
                                        icon={menu['icon']}
                                        open={menu['open']}
                                        >
                                        {menu['submenus'].map((submenu, indexx) => {
                                            if(!submenu['admin'] || (submenu['admin'] && isAdmin())) {
                                                return (
                                                    <MenuItem
                                                        key={indexx}
                                                        active={page === submenu['page'] ? true: false}
                                                        >
                                                        <Link to={submenu['link']} />
                                                        {submenu['title']}
                                                    </MenuItem>
                                                )
                                            } else {
                                                return null;
                                            }
                                        })}
                                    </SubMenu>
                                </Menu>
                            )
                        } else {
                            return null;
                        }
                    })}
                </SidebarContent>
                <SidebarFooter
                    style={{
                        display: 'flex',
                        borderTop: '0px',
                        fontSize: '15px',
                        justifyContent: 'center',
                        borderRight: '1px solid #DFDFDF' }}>

                </SidebarFooter>
            </ProSidebar>
        </div>
    )
}
